import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {filter, take, withLatestFrom} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {getKnowledgePathById} from '@shared/components/knowledge/store/knowledge.actions';
import {KnowledgeArticleStartDto} from '@server-models';
import {map} from 'rxjs/operators';
import {SharedKnowledgeState} from '../store/knowledge.state';
import {SharedKnowledgeSelectors} from '../store/knowledge.selectors-type';
import {SharedKnowledgeActions} from '@shared/components/knowledge/store/knowledge.actions-type';

export const sharedKnowledgePathDetailResolver: ResolveFn<KnowledgeArticleStartDto[] | null | undefined> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store: Store<SharedKnowledgeState> = inject(Store);
    const pathId: string = route.paramMap.get('pathId')!;
    const examId: string = route.paramMap.get('examId')!;

    store.dispatch((getKnowledgePathById({
      knowledgePathId: pathId,
      isRefresh: false
    })));

    if (examId) {
      store.dispatch(
        SharedKnowledgeActions.getExamAnswerById({
          examId: examId,
          pathId: pathId
        })
      );
    }

    return store.pipe(
      select(SharedKnowledgeSelectors.selectKnowledgePathModel),
      withLatestFrom(store.pipe(select(SharedKnowledgeSelectors.selectKnowledgePathLoading))),
      filter(([data, loading]) => !!data && !loading),
      take(1),
      map(([data]) => {
        return data?.articles?.sort((a, b) => a.position! - b.position!);
      })
    );
  };
